import { connect, useDispatch } from 'react-redux';
import { useState } from 'react';
import * as $ from 'jquery'
import { humanize, toggleId } from '../../../../../itrust_common/components/HelperFunctions'
import { previousExamLoad } from '../../../../../itrust_common/redux/actions/exam/previousExamActions'
import { examReset, examsLoad } from '../../../../../redux/actions/exam/examActions'
import Procedures from './Procedures'
import ContactLenses from './ContactLenses'
import EyeGlasses from './EyeGlasses'
import Alert from '../../../../../itrust_common/components/Alert';
import { orderUpdate } from '../../../../../redux/actions/order/orderActions';
import Impressions from './Impressions';
import DateFormatView from '../../../../../itrust_common/components/others/DateFormatView';
import { submit } from 'redux-form';
import { reportReset, reportUpdate } from '../../../../../redux/actions/reports/reportsActions';
import { previousReportLoad, previousReportsLoad } from '../../../../../redux/actions/reports/previousReportsAction';

function ImportWrapper(props) {
  const { importName, exams, previousExam, prescriptionModule, importNameTitle, addBtnLabel, prescription, order, report, reports } = props;
  const [activeExam, setActiveExam] = useState(null)
  const [selectedIds, setSelectedIds] = useState([])
  const dispatch = useDispatch()
  let reportDependent = (importName == 'contact_lens' || importName == 'eyeglass')

  const handlePreviousExamLoad = async (id) => {
    let tabName = ""
    let ids = [];
    let res;
    let resModule = (importName == 'contact_lens' || importName == 'eyeglass') ? 'report' : 'exam'
    switch (importName) {
      case "contact_lens": tabName = "finalized_lenses_attributes"; break
      case "eyeglass": tabName = "finalized_glasses_attributes"; break
      case "procedure": tabName = "procedures_attributes"; break
      case "impression": tabName = "impressions_attributes"; break
    }
    if (importName == 'contact_lens' || importName == 'eyeglass') {
      res = await dispatch(previousReportLoad(id, { include: '*' }))
    }
    else {
      res = await dispatch(previousExamLoad(id, { include: '*' }))
    }
    setSelectedIds([])
    res.value.data?.[resModule][tabName].map((item => ids.push(item.id)))
    setActiveExam(id)
    setSelectedIds(ids)
  }

  const handleIdsSelect = (ids, id) => {
    let idss = toggleId(ids, id)
    setSelectedIds(idss)
  }

  const getDefaultSelection = (exams) => {
    let id = null
    if (exams.length > 0) {
      id = exams[0].id
      handlePreviousExamLoad(id)
      setActiveExam(id)
    }
  }

  const openModel = async (importName, name) => {
    if (!prescription?.id && prescriptionModule) {
      dispatch(submit('PrescriptionForm'))
    }
    const loadAssociationModule = {
      contact_lens: 'finalized_lenses',
      eyeglass: 'finalized_glasses',
      procedure: 'procedures',
      impression: 'impressions'
    }
    const reportsFilter = { direction: 'desc', sort: 'report_date', rpp: 200, filter: { patient: order.patient_id, category: 'prescription', status: 'finalized', with_association: loadAssociationModule[name] } }

    const filter = { direction: 'desc', sort: 'exam_date', rpp: 200, filter: { patient: order.patient_id, with_association: loadAssociationModule[name] } }

    let res;
    const resModule = (name == 'contact_lens' || name == 'eyeglass') ? 'reports' : 'exams'

    if (name === 'contact_lens' || name === 'eyeglass') {
      res = await dispatch(previousReportsLoad(reportsFilter))
    }
    else {
      res = await dispatch(examsLoad(filter))
    }
    res = res.value.data[resModule]
    getDefaultSelection(res)
    $(`#${importName}`).modal()
  }

  const closeModel = () => {
    if (reportDependent && !prescription?.id) {
      dispatch(reportReset())
    }
    else {
      dispatch(examReset())
    }
    setSelectedIds([])
    $(`#${importName}-modal`).modal('hide');
  }

  const importData = () => {
    if (selectedIds.length === 0) {
      Alert.warning("No record selected!, Please select some values and than import it.")
    } else {
      let importData = selectedIds;
      if (importName === 'procedure' || importName === 'impression') {
        importData = getSelectedItemIdsAndPosition()
      }
      if (prescription?.id) {
        dispatch(reportUpdate({ id: prescription.id, [`import_${importName}_ids`]: importData }, { include: '*' }))
          .then(() => {
            setSelectedIds([])
            $(`#${importName}-modal`).modal('toggle')
          })
      }
      else {
        dispatch(orderUpdate({ id: order.id, [`import_${importName}_ids`]: importData }, { include: '*' }))
          .then(() => {
            setSelectedIds([])
            $(`#${importName}-modal`).modal('toggle')
          })
      }
    }
  }

  const getSelectedItemIdsAndPosition = () => {
    const data = {}
    previousExam[`${importName}s_attributes`].filter(obj => selectedIds.includes(obj.id)).map(obj => (data[obj.position] = obj.id));
    return data
  }

  const renderComponent = (importName) => {
    switch (importName) {
      case "procedure":
        return <Procedures handleIdsSelect={handleIdsSelect} selectedExam={previousExam} selectedIds={selectedIds} />
      case "contact_lens":
        return <ContactLenses handleIdsSelect={handleIdsSelect} selectedExam={report} selectedIds={selectedIds} />
      case "eyeglass":
        return <EyeGlasses handleIdsSelect={handleIdsSelect} selectedExam={report} selectedIds={selectedIds} />
      case "impression":
        return <Impressions handleIdsSelect={handleIdsSelect} selectedExam={previousExam} selectedIds={selectedIds} />
      default:
    }
  }

  const getHeaderSection = () => {
    return (
      <div className="d-flex align-items-end">
        <div className="d-flex flex-column">
          <h6 className="mr-3 d-inline-block mb-2">Date Selection</h6>
          <select className="custom-select" style={{ width: "15rem" }} value={activeExam} onChange={(e) => handlePreviousExamLoad(e.target.value)}>
            <option disabled value={null}></option>
            {reportDependent ?
              <>
                {reports.map(item =>
                  <option value={item.id}>
                    <DateFormatView date={item.created_at} />
                  </option>
                )}
              </> :
              <>
                {exams.map(exam =>
                  <option value={exam.id}>
                    <DateFormatView date={exam.exam_date} />
                  </option>
                )}
              </>
            }

          </select>
        </div>
        {activeExam &&
          <div className="d-flex flex-column ml-4">
            <h6 className="mr-3 d-inline-block mb-2"> Status:</h6>
            <span className="badge badge-primary rounded-sm">
              {humanize(reportDependent ? report.status : previousExam.status)}
            </span>
          </div>
        }
      </div>
    )
  }

  return (
    <div className="inner-modal">
      <button type="button" className={`btn btn-outline-primary ${prescriptionModule && 'mt-5 ml-4'}`} onClick={() => openModel(`${importName}-modal`, importName)}>
        {addBtnLabel ?? 'Add New from Exam'}
      </button>
      <div className="modal fade" data-backdrop="static" id={`${importName}-modal`} tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className={`modal-dialog modal-lg`} role="document">
          <div className="modal-content shadow-lg border-0">
            <div className="modal-header align-items-center">
              <h5 className="modal-title" id="exampleModalLabel">
                Import from {importNameTitle ?? humanize(importName)}
              </h5>
              <button type="button" className="btn btn-outline-primary" onClick={closeModel}>
                Close
              </button>
            </div>
            <div className="modal-body">
              <div className="d-flex align-items-center justify-content-between">
                {getHeaderSection()}
                <button type="button" className="btn btn-outline-primary" onClick={() => importData()}>
                  Import Selected
                </button>
              </div>
              {renderComponent(importName)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  const { exam, previousExam, previousReport } = state
  return {
    report: previousReport.report,
    reports: previousReport.reports,
    exams: exam.exams,
    previousExam: previousExam.previousExam
  }
}
export default connect(mapStateToProps)(ImportWrapper);